/* Shared cart helper + "Goes with" cart suggestion handler (Oct 28 2026). Loaded on every page from snippets/scripts.liquid.

   window.pmCartAdd(items)
     items: [{ id: variantId, quantity: n }]. Adds to the cart and asks Shopify for the fresh HTML of every
     cart-items-component (cart drawer, cart page) in the same request, then fires the theme's cart:update event
     with those sections. Horizon morphs the drawer from that HTML immediately and the header count goes up by
     the quantity added. Without the sections, the drawer had to fetch itself again and showed the old cart
     for a moment. Resolves with Shopify's response; rejects with Error(description) when Shopify refuses
     (for example, not enough stock).
     Used by: this file, sections/pm-pdp-routine.liquid, assets/pmf.js.

   "+ Add" in the cart suggestion (snippets/pm-cart-suggest.liquid) is delegated on document, so it works for
   suggestion blocks that appear later when the drawer is re-rendered (scripts inside re-rendered HTML never run). */
(function () {
  if (window.__pmCsInit) return;
  window.__pmCsInit = true;

  window.pmCartAdd = async function (items) {
    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (sectionIds.indexOf(el.dataset.sectionId) === -1) sectionIds.push(el.dataset.sectionId);
    });
    var body = { items: items };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }
    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json();
    if (!res.ok) {
      var err = new Error(data.description || data.message || 'error');
      err.data = data;
      throw err;
    }
    var added = items.reduce(function (n, it) { return n + (Number(it.quantity) || 1); }, 0);
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: data, sourceId: 'pm-cart', data: { itemCount: added, source: 'product-form-component', sections: data.sections } }
    }));
    return data;
  };

  /* Scroll-lock fix (Oct 28 2026). Horizon's dialogs (cart drawer, search, etc.) lock page scroll with
     body{position:fixed} and only unlock in closeDialog(). closeDialog() runs on Escape only while focus is inside
     the dialog. If focus has left it (e.g. the clicked "+ Add" button was disabled and then re-rendered), Escape
     makes the browser close the <dialog> natively, closeDialog() never runs, and the page stays frozen.
     Route the browser's own cancel through the theme's close so the lock is always released. */
  document.addEventListener('cancel', function (e) {
    var dialog = e.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    var host = dialog.parentElement;
    while (host && typeof host.closeDialog !== 'function') host = host.parentElement;
    if (!host) return;
    e.preventDefault();
    host.closeDialog();
  }, true);

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-pm-cs-add]');
    if (!btn || btn.disabled) return;
    var box = btn.closest('.pm-cs');
    var status = box && box.querySelector('.pm-cs__status');
    btn.disabled = true;
    if (status) status.textContent = 'Adding…';
    try {
      await window.pmCartAdd([{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }]);
      if (status) status.textContent = 'Added to your cart';
    } catch (err) {
      if (status) status.textContent = (err && err.message && err.message !== 'error') ? err.message : 'Sorry, that didn’t work. Please try again.';
      btn.disabled = false;
    }
  });
})();
